<template>
    <div>
        <div v-if="readMode">
            <span class="select-bank-title">{{resources.banks.selectBank}}</span>
        </div>
        <div class="giftcard-details-form vue-form">
            <div class="vue-form-row">
                <vue-input
                    :element="bankOptionsField"
                    :key="bankOptionsField.id"
                    tabindex=""
                    @blur="updateSelectedBank(bankOptionsField.id, $event.target.value)">
                </vue-input>
            </div>
        </div>
    </div>
</template>

<script src='./banks.js'></script>
